import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Download, X } from "lucide-react";
import { NxButton } from "@/components/ui/NxButton";
import pt from "@/lib/i18n";

const VISIT_KEY = "nexustel-visit-count";
const DISMISSED_KEY = "nexustel-install-dismissed";

export const InstallPwaBanner = () => {
    const [prompt, setPrompt] = useState(null);
    const [show, setShow] = useState(false);

    useEffect(() => {
        try {
            const visits = parseInt(localStorage.getItem(VISIT_KEY) || "0", 10) + 1;
            localStorage.setItem(VISIT_KEY, String(visits));
            const dismissed = localStorage.getItem(DISMISSED_KEY) === "true";
            if (visits < 2 || dismissed) return;
        } catch (e) { return; }

        const onPrompt = (e) => {
            e.preventDefault();
            setPrompt(e);
            setShow(true);
        };
        window.addEventListener("beforeinstallprompt", onPrompt);
        return () => window.removeEventListener("beforeinstallprompt", onPrompt);
    }, []);

    const install = async () => {
        if (!prompt) return;
        prompt.prompt();
        try { await prompt.userChoice; } catch (e) {}
        setShow(false);
        setPrompt(null);
    };

    const dismiss = () => {
        try { localStorage.setItem(DISMISSED_KEY, "true"); } catch (e) {}
        setShow(false);
    };

    return (
        <AnimatePresence>
            {show && (
                <motion.div
                    initial={{ y: 60, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: 60, opacity: 0 }}
                    className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 w-[min(92vw,520px)]"
                    data-testid="install-banner"
                >
                    <div className="rounded-2xl border-2 backdrop-blur-xl p-4 shadow-lg flex items-center gap-3"
                        style={{ background: "rgba(255,247,237,0.94)", borderColor: "var(--copper)" }}>
                        <div className="rounded-lg p-2.5" style={{ background: "var(--copper-subtle)", color: "var(--copper-dark)" }}>
                            <Download size={18} />
                        </div>
                        <div className="flex-1">
                            <p className="font-body text-sm font-medium text-[color:var(--slate-deep)]">Instale o NexusTel no seu dispositivo</p>
                            <p className="font-body text-xs text-[color:var(--slate-mid)]">{pt.common?.pwaInstallHint || "Acesso rápido e modo offline para o terreno."}</p>
                        </div>
                        <NxButton variant="copper" size="sm" onClick={install} data-testid="btn-install">Instalar</NxButton>
                        <button onClick={dismiss} className="text-[color:var(--slate-mid)] hover:text-[color:var(--slate-deep)] p-1" aria-label="Dispensar" data-testid="btn-dismiss-install">
                            <X size={16} />
                        </button>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default InstallPwaBanner;
